import {Component, Input, OnInit} from '@angular/core';
import {NgIf} from "@angular/common";
import {TableModule} from "primeng/table";
import {PersonaInfo} from "../../../../../shared/interfaces/shared-interface";
import {ProyectoItem} from "../../../../interfaces/proyecto.interface";
import {Param} from "../../../../../shared/interfaces/param-interface";
import {PersonasService} from "../../../../../shared/services/personas-service";
import {InputMaskModule} from "primeng/inputmask";
import {FormsModule} from "@angular/forms";
import {PhoneFormatPipe} from "../../../../../shared/pipes/PhoneFormatPipe";

@Component({
    selector: 'app-informacion-general-cliente',
    standalone: true,
    imports: [
        NgIf,
        TableModule,
        InputMaskModule,
        FormsModule,
        PhoneFormatPipe
    ],
    templateUrl: './informacion-general-cliente.component.html',
    styleUrl: './informacion-general-cliente.component.scss'
})
export class InformacionGeneralClienteComponent implements OnInit {
    @Input("prj") prj!: ProyectoItem | null;
    datosCliente!: PersonaInfo;

    constructor(private personaService: PersonasService) {
    }

    ngOnInit(): void {
        this.getInformacionCliente();
    }

    getInformacionCliente() {
        const params: Param[] = [{key: 'correo', value: this.prj?.creadoPor}];
        this.personaService.consultaInfo(params).subscribe({
            next: (respuesta: any) => {
                this.getInformacionClienteUniqueId(respuesta.body[0].uniqueId!);
            },
            error: () => {
                // Manejo de errores si es necesario;
            },
            complete: () => {
            }
        });
    }

    getInformacionClienteUniqueId(uniqueId: string) {
        const params: Param[] = [{key: 'uniqueids', value: uniqueId}];
        this.personaService.consultaInfo(params).subscribe({
            next: (respuesta: any) => {
                this.datosCliente = respuesta.body?.[0] ?? null;
            },
            error: () => {
                // Manejo de errores si es necesario;
            },
            complete: () => {
            }
        });
    }

    getContactoValue(index: number): string {
        const contactos = this.datosCliente?.contactos;
        if (!contactos || !Array.isArray(contactos) || !contactos[index] || !contactos[index].contacto) {
            return 'N/A';
        }
        return contactos[index].contacto.trim() === '' ? 'N/A' : contactos[index].contacto;
    }
}
